import { render } from "./SecondBar.vue?vue&type=template&id=118d66bc&scoped=true"
import script from "./SecondBar.vue?vue&type=script&lang=js"
export * from "./SecondBar.vue?vue&type=script&lang=js"

import "./SecondBar.vue?vue&type=style&index=0&id=118d66bc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118d66bc"]])

export default __exports__